import { NgModule } from '@angular/core';
import { IonicModule }  from 'ionic-angular'

import { RcsKdJobSearchComponent } from '../components/rcs-kd-job-search/rcs-kd-job-search';
import { RcsKdJobListComponent } from '../components/rcs-kd-job-list/rcs-kd-job-list';

@NgModule({
  declarations: [
    RcsKdJobSearchComponent,
    RcsKdJobListComponent,
  ],
  imports: [IonicModule],
  exports: [
    RcsKdJobSearchComponent,
    RcsKdJobListComponent,
  ]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/pages/components.module.ts